import { useEffect } from "react";

import { FiltersContainer } from "../../filters/ui/FiltersContainer";

import { AlertType } from "./AlertType";
import { Search } from "./Search";
import { TrafficType } from "./TrafficType";
import { useSeoAlertsFilterStore } from "./useSeoAlertsFilterStore";

export const SeoAlertsFilters = () => {
    const reset = useSeoAlertsFilterStore((state) => state.reset);

    useEffect(() => reset, [reset]);

    return (
        <FiltersContainer>
            <TrafficType />
            <AlertType />
            <Search />
        </FiltersContainer>
    );
};
